<script setup lang="ts">import { ref as _ref } from 'vue';

import Modal from '@/components/Modal.vue'
import { Btn } from '@bagelink/vue'

const open = _ref(true)
</script>

<template>
	<Modal v-if="open" v-model:visible="open" width="600px" class="popupWrap">
		<div class="relative z-2 color-white txt-center border mt-7 mb-05 m_mt-4 m_pt-1 m_mb-1">
			<p class="txt50 playfair m_txt30">
				{{ $t("popup.needMoreClarity") }}
			</p>
			<p class="balance txt20">
				{{ $t("popup.weReHereToSupportYou") }}
			</p>
			<div class=" -mb-1-5">
				<Btn color="primary" class="mt-1-5 round color-white" @click="$emit('close')">
					{{ $t("popup.bookOnlineMeeting") }}
				</Btn>
			</div>
		</div>
		<img class="absolute inset-0 h-100p w-100p cover" src="@/assets/popup3.jpg" alt="popup">
	</Modal>
</template>

<style scoped>
.popupWrap{
	--border-color: var(--bgl-primary);
}
</style>
